import React, { FC } from 'react';
import { Alert } from 'antd';
import { ApiError } from '../ApiClient';
import { GetApiErrorMessage } from '../utils/ValidationMessagesMap';

interface ApiAlertsProps {
  errors: ApiError[];
  onChange: (errors: ApiError[]) => void;
  translateError: GetApiErrorMessage;
}

function removeItem(errors: ApiError[], removed: number) {
  return errors.filter((_, i) => i !== removed);
}

export const ApiAlerts: FC<ApiAlertsProps> = ({
  errors,
  onChange,
  translateError,
}) => {
  return (
    <>
      {errors.map((error, i) => (
        <Alert
          key={i}
          type="error"
          onClose={() => onChange(removeItem(errors, i))}
          closable={true}
          message={translateError(error.code)}
        />
      ))}
    </>
  );
};
